import $ from "jquery";
import { modal } from "../../modal";
import { cloneableFactory } from "../../cloneable";
import { datePickerFactory } from "../datePicker";
import { LocalMultiSelect } from "./local/multiSelect";
import { LocalSingleSelect } from "./local/singleSelect";
import { RemoteCustomSelect } from "./remote/customSelect";
export const initialiseInput = (input) => {
    if (input.is("select"))
        initialiseLocal(input);
    if (input.is("input[type='hidden'][data-custom-select-url]"))
        initialiseRemote(input);
};
const initialiseContainer = (container, renderInline = false) => {
    initialiseLocal($(container).find("select"), renderInline);
    initialiseRemote($(container).find("input[type='hidden'][data-custom-select-url]"), renderInline);
};
const cleanUp = (container) => {
    const nativeSelects = $(container).find("select");
    getModels(nativeSelects).forEach((m) => m.cleanUp());
};
export const initialiseLocal = (nativeSelects, renderInline = false) => {
    nativeSelects.toArray().forEach((n) => {
        const nativeSelect = $(n);
        if (nativeSelect.data("custom-select-model"))
            return;
        const customSelect = nativeSelect.prop("multiple")
            ? new LocalMultiSelect(nativeSelect, renderInline)
            : new LocalSingleSelect(nativeSelect, renderInline);
        customSelect.render();
        nativeSelect.data("custom-select-model", customSelect);
    });
};
export const initialiseRemote = (hiddenInputs, renderInline = false) => {
    hiddenInputs.toArray().forEach((h) => {
        const hiddenInput = $(h);
        if (hiddenInput.data("custom-select-model"))
            return;
        const customSelect = new RemoteCustomSelect(hiddenInput, renderInline);
        customSelect.render();
        hiddenInput.data("custom-select-model", customSelect);
    });
};
export const getModels = (nativeSelects) => {
    return nativeSelects
        .toArray()
        .map((n) => {
        const nativeSelect = $(n);
        return nativeSelect.data("custom-select-model");
    })
        .filter((m) => !!m);
};
export const isCustomSelect = (input) => input.is("select,input[type='hidden'][data-custom-select-url]");
modal.on("show", (modal) => initialiseContainer(modal));
modal.on("hide", (modal) => cleanUp(modal));
cloneableFactory.on("itemAdded", (row) => {
    $(row).find(".custom-select").remove();
    initialiseContainer(row);
});
cloneableFactory.on("itemRemoved", (row) => cleanUp(row));
datePickerFactory.on("rendered", (container) => {
    cleanUp(container);
    initialiseContainer(container, true);
});
datePickerFactory.on("removed", (picker) => cleanUp(picker));
$(() => initialiseContainer(document));
